export const testimonials = [
  {
    id: 1,
    name: 'Michael R.',
    location: 'Tampa, FL',
    rating: 5,
    text: 'Professional, clean work, and incredible results. Our patio completely transformed our backyard. The team was on time every day and the craftsmanship is outstanding. Highly recommend Parkside Pavers!',
    platform: 'Google',
  },
  {
    id: 2,
    name: 'Jennifer M.',
    location: 'Clearwater, FL',
    rating: 5,
    text: 'Highly recommend — the driveway looks amazing and has held up perfectly. We got multiple quotes and Parkside gave us the best combination of price, quality, and communication throughout the project.',
    platform: 'Google',
  },
  {
    id: 3,
    name: 'David L.',
    location: 'St. Petersburg, FL',
    rating: 5,
    text: 'From the first consultation to the final walkthrough, the entire experience was seamless. They installed a gorgeous pool deck and patio for us. Neighbors keep asking who did the work!',
    platform: 'Yelp',
  },
  {
    id: 4,
    name: 'Susan T.',
    location: 'Tarpon Springs, FL',
    rating: 5,
    text: 'Parkside Pavers exceeded every expectation. The retaining wall and walkway they built are both beautiful and functional. Communication was clear, pricing was fair, and the finished product is stunning.',
    platform: 'Google',
  },
  {
    id: 5,
    name: 'Carlos V.',
    location: 'Tampa, FL',
    rating: 5,
    text: 'These guys are the real deal. ICPI certified, professional crew, and they use top-quality materials. My driveway went from cracked concrete to a showpiece. Wish I had done it years ago.',
    platform: 'Google',
  },
  {
    id: 6,
    name: 'Amanda B.',
    location: 'Clearwater, FL',
    rating: 5,
    text: 'We had a full outdoor living space installed — patio, seating wall, and fire feature. The design consultation process was thorough and the end result is exactly what we envisioned. Five stars all around.',
    platform: 'Google',
  },
];
